import React, { useEffect, useState } from 'react'

import {Fechas,FiltroModalidades,Setting} from "./OpcionesDrawer"
import { useMainContext } from "../MainContext";

import "./Drawer.scss"

function Drawer() {
    const { state } = useMainContext();
    const [clase, setclase] = useState("activo")
    
    useEffect(() => {
        setclase("activo")
        if(!state.ui.drawer.visible){
            setTimeout(() => {
                setclase("")
            }, 250);
        }
        return () => {
            //cleanup
        }
    }, [state.ui.drawer.visible])
    return (
        <div id="Drawer" className={clase}>
            <Caja />
            <Velo />
        </div>
    )
}


export default Drawer

const Caja = ()=>{
    const { state, dispatch } = useMainContext();
    const activo = state.ui.drawer;
    const onClose = () => dispatch({ type: 'SET_DRAWER', payload: { visible: false, componente: null } });

    let componente;
    switch (activo.componente) {
      case 0:
        componente = <Fechas />;
        break;
      case 1:
        componente = <FiltroModalidades />;
        break;
      case 2:
        componente = <Setting />;
        break;

      default:
        break;
    }
    return(
        <div className={activo.visible?"Caja activo":"Caja"}>
            <div className="CerrarDrawer" onClick={onClose}>X</div>
            {componente}
        </div>
    )
}

const Velo = ()=>{
    const { state, dispatch } = useMainContext();
    const activo = state.ui.drawer;
    const onClose = () => dispatch({ type: 'SET_DRAWER', payload: { visible: false, componente: null } });
    return(
        <div className={activo.visible?"Velo activo":"Velo"} onClick={onClose}></div>
    )
}